import { render, staticRenderFns } from "./ProductMgmtConfig.vue?vue&type=template&id=0ec90a08&scoped=true"
import script from "./ProductMgmtConfig.vue?vue&type=script&lang=js"
export * from "./ProductMgmtConfig.vue?vue&type=script&lang=js"
import style0 from "./ProductMgmtConfig.vue?vue&type=style&index=0&id=0ec90a08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec90a08",
  null
  
)

export default component.exports